import {
  ProcessRouteStepInput,
  ProcessRouteStepInputFragment,
} from "gql/graphql";
import { valueOrNull } from "@/shared/value";

/** Шаг из DTO (фрагмент ProcessRouteStepInput) → начальное значение формы в той же форме. */
export function toProcessRouteStepFormValue(
  step: ProcessRouteStepInputFragment,
): ProcessRouteStepInput {
  if (step.__typename === "RoleProcessRouteStepDto") {
    return { role: step.role.code };
  }

  if (step.__typename === "PersonProcessRouteStepDto") {
    const person = valueOrNull(step.person)?.id;

    return person ? { person } : {};
  }

  return {};
}
